import type { ReactNode } from "react";

import { ChevronDownIcon } from "./i/chevron-down";

export function TriggerField({
  icon,
  label,
  hasValue,
  onClick,
  ...analytics
}: {
  /** 左側アイコン（20×20px の ReactNode） */
  icon: ReactNode;
  /** 表示テキスト（値またはプレースホルダ） */
  label: string;
  /** 値が設定されているか（ボーダー・テキスト色が変わる） */
  hasValue: boolean;
  onClick: () => void;
  /** 開くポップアップが呼び出し元ごとに違うため、id は呼び出し側で決める */
  "data-analytics-id": string;
}) {
  return (
    <button
      {...analytics}
      type="button"
      onClick={onClick}
      className="focus-visible:ring-dx-border-focus hover:bg-dx-bg-base-hover flex w-full items-start rounded-t-[2px] pr-[2px] pl-[8px] transition-colors duration-150 focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:outline-none"
    >
      <span
        className={
          hasValue
            ? "border-dx-text-sub flex w-full items-center border-b-[1.5px]"
            : "border-dx-text-muted flex w-full items-center border-b"
        }
      >
        <span className="flex shrink-0 items-center py-[12px] pr-[4px]">
          <span className="size-[20px] shrink-0">{icon}</span>
        </span>
        <span className="min-w-px flex-1 py-[8px] pr-[8px] pl-[4px] text-left">
          <span
            className={
              hasValue
                ? "font-notojp text-dx-text-default text-[16px] leading-[28px]"
                : "font-notojp text-dx-text-muted text-[16px] leading-[28px]"
            }
          >
            {label}
          </span>
        </span>
        <span className="flex shrink-0 items-center justify-center px-[4px] py-[10px]">
          <ChevronDownIcon className="size-[24px] shrink-0" />
        </span>
      </span>
    </button>
  );
}
